import React from 'react'
// import About from '../Component/About'
// import AboutBreadcrumb from '../Component/AboutBreadcrumb'
import Header from '../Component/Header'
import Footer from '../Component/Footer'
import Contact from '../Component/Contact'
import ContactBreadcrumb from '../Component/ContactBreadcrumb'
// import FAQ from '../Component/FAQ'
function ContactPage() {
    return (
        <div>
            <Header />
            {/* <AboutBreadcrumb /> */}
            {/* <ContactPage /> */}
            {<ContactBreadcrumb />}
            <Contact />
            <Footer />
        </div>
    )
}

export default ContactPage